import React from "react";
import { Chart } from "react-google-charts";

const data = [
  ["Country", "Popularity"],
  ["Germany", 200],
  ["United States", 300],
  ["Brazil", 400],
  ["Canada", 500],
  ["France", 600],
  ["RU", 700],
];

const options = {
  colorAxis: { colors: ["#F11E69", "#F11E69"] }, // Custom single color range
};

function EarthChart() {
  return (
    <Chart
      //   chartEvents={[
      //     {
      //       eventName: "select",
      //       callback: ({ chartWrapper }) => {
      //         const chart = chartWrapper.getChart();
      //         const selection = chart.getSelection();
      //         if (selection.length === 0) return;
      //         const region = data[selection[0].row + 1];
      //         console.log("Selected : " + region);
      //       },
      //     },
      //   ]}
      chartType="GeoChart"
      data={data}
      options={options} // Apply the custom color options
    />
  );
}

export default EarthChart;
